var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPowerOffer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eaYSWl59rqw1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 257 256",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eaYSWl59rqw2_ts",
    transform: "translate(210.5,182.410004) scale(1,1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-210.5,-182.410004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.5,184c0,18.98,16.02,34,35,34s35-16.02,35-35-16.02-34-35-34-35,16.02-35,35Z",
    transform: "translate(0-1.09)",
    fill: "#83ca32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.5,209c12.89-2.64,22.66-13.18,23.72-26.59",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.5,180c0,0-1,2,0,5",
    transform: "translate(0-.09)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.5,151c-9.57,2.2-17.37,9.07-21,18",
    transform: "translate(0-.09)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.5,180c0,18.98,14.02,34,33,34s36-15.02,36-34-16.02-35-35-35-34,16.02-34,35Z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.14,180.29h-6.86c-3.75,0-6.78-3.1-6.78-6.92s3.04-6.92,6.78-6.92h12.15",
    transform: "translate(.07 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.5,159v7",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.5,195v6",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.8,180.29h6.86c3.75,0,6.78,3.1,6.78,6.92s-3.04,6.92-6.78,6.92h-12.33",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.39,83.1501c0-5.08,4.64-9.49,9.72-9.49h36.48c-6.44-12.25-19.8-20.33-34.61-20.33-21.26,0-38.49001,17.23-38.49001,38.49C7.48999,109.04,18.79,123.61,34.38,128.53v-45.3799h.01Z",
    fill: "#e1e6ed"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.39,109.49c-2.43,0-4.69.74-6.57,2v19.56c1.88,1.26,4.14,2,6.57,2c6.51,0,11.78-5.27,11.78-11.78s-5.27-11.78-11.78-11.78v0Z",
    fill: "#e1e6ed"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.5,195h-126c-5.08,0-9-3.92-9-9",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M176.5,75h36c5.08,0,9,4.92,9,10l.26,54.32",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.37,144.75v-47.1202l-.08-13.42c0-5.08,4.12-9.2,9.2-9.2h99",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M175.5,208h-112",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.47,88.0102c1.3862,0,2.51-1.1237,2.51-2.51s-1.1238-2.51-2.51-2.51-2.51,1.1238-2.51,2.51s1.1237,2.51,2.51,2.51Z",
    fill: "#ff7574",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.88,88.0102c1.3862,0,2.51-1.1237,2.51-2.51s-1.1238-2.51-2.51-2.51-2.51,1.1238-2.51,2.51s1.1238,2.51,2.51,2.51Z",
    fill: "#ffc692",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.23,88.0102c1.3862,0,2.51-1.1237,2.51-2.51s-1.1238-2.51-2.51-2.51c-1.3863,0-2.51,1.1238-2.51,2.51s1.1237,2.51,2.51,2.51Z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.51,39.0204l-3.01-3.02c-2.26-2.26-2.26-5.74,0-8l3-3c2.26-2.26,5.93-2.56,8.19-.31l3.07,3.07c2.26,2.26,2.26,5.92,0,8.18l-3.07,3.07c-2.26,2.26-5.92,2.26-8.18,0v.01Z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M248.5,102c0,2.92-2.08,5-5,5s-5-2.08-5-5s1-6,5-6s5,3.08,5,6Z",
    fill: "#fff924",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.53,57.1402l4.83,5.34l4.93-4.94l5.39,5.39l6.18-6.19l6.28,6.28l6.46-5.88l5.94,5.44l5.41-5.44",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M207.26,56.48l5.38,5.39l6.18-6.19l6.28,6.28l6.43-6.42",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M154.342,127.147h-13.376c.064.972.386,1.944.965,2.851.514.778,1.157,1.426,1.929,1.88s1.608.648,2.508.648c.965,0,1.929-.194,2.765-.713.772-.518,1.351-1.231,1.672-2.074h3.087c-.321,1.037-.836,1.944-1.543,2.722-.708.843-1.608,1.491-2.637,1.944-1.222.519-2.508.778-3.794.713s-2.572-.453-3.73-1.166c-1.222-.778-2.251-1.815-2.958-3.111-.708-1.361-1.094-2.852-1.094-4.342c0-1.556.386-3.046,1.094-4.342.707-1.297,1.736-2.398,2.958-3.176c1.286-.778,2.701-1.167,4.18-1.167c1.415,0,2.83.389,4.116,1.167c1.222.713,2.186,1.815,2.83,3.046.707,1.231,1.028,2.657,1.028,4.083.065.065.065.454,0,1.037Zm-2.701-2.398c-.064-.778-.321-1.555-.836-2.139-.514-.648-1.157-1.231-1.929-1.62s-1.672-.583-2.508-.583c-.772,0-1.608.194-2.315.518s-1.351.843-1.865,1.491c-.515.713-.9,1.49-1.093,2.333h10.546Z",
    fill: "#83ca32"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M159.68,134.664h-2.765v-9.073c0-1.945.771-3.889,2.122-5.25c1.35-1.426,3.215-2.203,5.145-2.203h1.8v2.786h-1.8c-1.222,0-2.38.519-3.216,1.361-.836.843-1.35,2.074-1.35,3.306l.064,9.073Z",
    fill: "#83ca32"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M128.232,117.749c-2.187,0-4.309.843-5.916,2.398l.064-8.166h-2.701v14.518c0,1.685.514,3.37,1.479,4.795.965,1.426,2.251,2.528,3.859,3.176c1.543.648,3.279.842,4.951.454c1.672-.324,3.152-1.167,4.373-2.398c1.158-1.232,1.994-2.787,2.316-4.472.321-1.685.128-3.435-.515-4.99-.643-1.556-1.736-2.917-3.151-3.889-1.415-.907-3.087-1.426-4.759-1.426Zm0,14.777c-1.158,0-2.315-.389-3.344-1.037-.965-.648-1.736-1.62-2.187-2.722-.45-1.102-.578-2.333-.321-3.5.257-1.166.772-2.268,1.608-3.111.836-.842,1.929-1.425,3.086-1.685c1.158-.259,2.38-.129,3.473.324c1.093.454,2.058,1.232,2.701,2.269.643.972,1.029,2.203,1.029,3.37c0,1.62-.643,3.175-1.736,4.277-1.158,1.167-2.701,1.815-4.309,1.815Z",
    fill: "#83ca32"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M183.796,118.138h-6.045v-6.157h-2.766v6.157h-6.045v2.787h6.045v6.157h2.766v-6.157h6.045v-2.787Z",
    fill: "#83ca32"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4341,118.851v-2.333h-2.3151v2.333h-2.3152v2.333h2.3152v2.333h2.3151v-2.333h2.3152v-2.333h-2.3152Z",
    fill: "#83ca32"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5529,121.184v-2.333h-2.3151v2.333h-2.3152v2.333h2.3152v2.333h2.3151v-2.333h2.3151v-2.333h-2.3151Z",
    fill: "#83ca32"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5529,111.852v-2.333h-2.3151v2.333h-2.3152v2.333h2.3152v2.333h2.3151v-2.333h2.3151v-2.333h-2.3151Z",
    fill: "#83ca32"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4145,123.711v-1.879h-1.865v1.879h-1.8649v1.88h1.8649v1.879h1.865v-1.879h1.865v-1.88h-1.865Z",
    fill: "#83ca32"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1642,116.712v-1.815h-1.865v1.88h-1.8007v1.879h1.865v1.88h1.865v-1.88h1.865v-1.879h-1.9293v-.065Z",
    fill: "#83ca32"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8684,128.184v-2.333h-2.3151v2.333h-2.3151v2.333h2.3151v2.333h2.3151v-2.333h2.3152v-2.333h-2.3152Z",
    fill: "#83ca32"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M93.119,114.186h-2.3152v2.333h2.3152v-2.333Z",
    fill: "#83ca32"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4348,111.852h-2.3152v2.333h2.3152v-2.333Z",
    fill: "#83ca32"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4348,125.851h-2.3152v2.333h2.3152v-2.333Z",
    fill: "#83ca32"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5279,121.702v-1.167h-1.1576v1.167h-1.2219v1.166h1.1576v1.167h1.2219v-1.167h1.1576v-1.166h-1.1576Z",
    fill: "#83ca32"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4117,119.37v-1.167h-1.2219v1.167h-1.1576v1.166h1.1576v1.167h1.1576v-1.167h1.1575v-1.166h-1.0932Z",
    fill: "#83ca32"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7492,118.851h-2.3152v-2.334h-2.3151v-1.944L81.929,129.155c-.3858.454-.5788,1.037-.7074,1.62-.0643.584,0,1.167.193,1.75s.5144,1.037.9646,1.426.9646.648,1.5434.778v-1.88h-2.2508v-2.333h2.3151v-2.333h2.3152v2.333h2.3151v1.361l2.8296-3.694h-.5144v-2.333h-2.3152v-2.333h2.3152v-2.333h2.3151v2.333h1.8007l.4501-.584v-1.749h2.2509v-2.333ZM95.434,112.37c-.6431.324-1.2218.777-1.672,1.361l-.3216.453h1.9936v-1.814ZM100,121.184h2.315v-3.565-.842c0-1.232-.45-2.463-1.35-3.37-.836-.908-1.9939-1.426-3.2801-1.491v2.268h2.3151v2.333h-2.2508v2.334h2.3148L100,121.184Zm2.315,6.61v-4.277h-2.315v2.333h-2.2508v-2.333h-2.2509v8.166c0,.712.193,1.425.6431,2.009.3859.583,1.029,1.037,1.6721,1.296s1.4148.259,2.0579.065c.7076-.195,1.2866-.648,1.7366-1.167.128-.13.257-.259.321-.389l2.38-3.111c-.579-.129-1.094-.453-1.415-.907-.386-.518-.579-1.102-.579-1.685ZM86.2378,134.34c.3858-.195.7717-.519,1.0932-.908l.4502-.583h-1.5434v1.491ZM116.013,120.6c-.579-.453-1.286-.648-1.994-.583-.707.065-1.35.454-1.8,1.037l-2.187,2.852v7.712c0,.907.386,1.814,1.029,2.462.643.649,1.479,1.037,2.444,1.037s1.801-.388,2.444-1.037c.643-.648,1.029-1.555,1.029-2.462v-9.786c-.258-.454-.579-.908-.965-1.232Zm-2.315-8.425c-.965-.324-1.929-.324-2.894-.065-.965.26-1.801.843-2.379,1.685l-5.338,6.935v7.323c0,.454.128.908.321,1.296.193.389.579.713.965.973l3.859-5.055l3.665-4.796c.322-.389.772-.713,1.222-.908.45-.194,1.029-.259,1.544-.194.514.065.964.324,1.414.648.386.324.708.778.901,1.231v-4.471c0-1.037-.322-2.009-.901-2.787-.643-.843-1.479-1.491-2.379-1.815Z",
    fill: "#83ca32"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9873,135.118v-2.333h-2.3151v2.333h-2.3151v2.333h2.3151v2.333h2.3151v-2.333h2.3152v-2.333h-2.3152Z",
    fill: "#83ca32"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M185.272,115.389c-.329-.188-.589-.445-.777-.767-.191-.323-.285-.674-.285-1.056s.094-.735.285-1.058.451-.576.777-.767c.328-.188.688-.282,1.083-.282s.755.094,1.083.282c.329.188.589.444.777.767.191.323.285.673.285,1.058c0,.382-.094.733-.285,1.056-.191.322-.451.576-.78.767-.328.188-.689.282-1.083.282-.392.003-.752-.094-1.08-.282Zm2.004-.241c.278-.16.498-.376.66-.655.163-.275.245-.585.245-.923c0-.342-.082-.652-.245-.93-.162-.279-.382-.495-.66-.655-.279-.16-.586-.238-.918-.238s-.636.078-.914.238c-.279.16-.501.376-.664.655-.163.278-.244.588-.244.93c0,.341.081.651.244.926.163.276.385.495.664.652.278.159.582.238.914.238s.636-.079.918-.238Zm-.761-2.797c.141,0,.269.032.385.101.116.065.21.156.279.272.068.116.103.241.103.382c0,.154-.041.291-.122.413-.082.123-.188.21-.323.263l.489.984h-.332l-.451-.918c-.025.003-.063.007-.113.007h-.554v.911h-.313v-2.411h.952v-.004Zm.222,1.181c.072-.044.132-.103.172-.182.041-.075.063-.159.063-.247s-.022-.169-.063-.247c-.044-.076-.1-.138-.175-.182-.072-.044-.154-.069-.241-.069h-.617v.993h.617c.091,0,.169-.022.244-.066Z",
    fill: "#83ca32"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M144.49,166.49h2.7c4.46,0,8.31-2.8,8.31-7.23s-3.57-8.26-8.02-8.26h-37.91c-4.46,0-8.07,3.83-8.07,8.26s3.61,7.78,8.07,7.78h10.81",
    fill: "#e1e6ed"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M144.49,166.49h2.7c4.46,0,8.31-2.8,8.31-7.23s-3.57-8.26-8.02-8.26h-37.91c-4.46,0-8.07,3.83-8.07,8.26s3.61,7.78,8.07,7.78h10.81",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M137.92,166.13l-11.89-5.08-2.53,12.68l3.51-1.85l7.34,13.92l7.39-3.89-7.33-13.93l3.51-1.85Z",
    fill: "#96c600"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M139.47,167.09l-11.89-5.08-2.53,12.68l3.52-1.85l7.33,13.93l7.4-3.9-7.34-13.93l3.51-1.85Z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M154.07,70.8699c1.85,0,3.35-1.4998,3.35-3.35s-1.5-3.35-3.35-3.35-3.35,1.4999-3.35,3.35s1.5,3.35,3.35,3.35Z",
    fill: "#fff924",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M167.76,84.5594c1.85,0,3.35-1.4999,3.35-3.35c0-1.8502-1.5-3.35-3.35-3.35s-3.35,1.4998-3.35,3.35c0,1.8501,1.5,3.35,3.35,3.35Z",
    fill: "#fff924",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M172.79,63.0195l-14.37,14.38-8.48,8.48",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M31.24,213.96l2.07-2.06",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M40.53,213.96l2.07-2.06",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8199,213.96l2.07-2.06",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M31.24,223.25l2.07-2.06",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M40.53,223.25l2.07-2.06",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8199,223.25l2.07-2.06",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M31.24,232.54l2.07-2.06",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M40.53,232.54l2.07-2.06",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8199,232.54l2.07-2.06",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5,97h-186",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eaYSWl59rqw81)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M67.4706,163.747c-.3925.771-.672,1.635-.8147,2.553-.1665-.118-.3449-.188-.547-.188-.666,0-1.2012.753-1.2012,1.676c0,.924.5411,1.677,1.2012,1.677.2021,0,.3924-.077.5589-.2.6006,3.523,3.217,6.182,6.3567,6.182c3.1396,0,5.7679-2.665,6.3625-6.194.1725.135.3687.218.5828.218.666,0,1.2011-.753,1.2011-1.677c0-.923-.5411-1.676-1.2011-1.676-.2081,0-.3984.076-.5649.206",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0978,160.705c0,0-1.1595,2.295,1.4509,4.736l.773,1.341c0,0,2.3667-2.006.9158-5.212-1.219-1.947-3.1397-.859-3.1397-.859v-.006Z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8183,160.782c0,0-.6303,1.723-3.9127,1.67-3.2883-.047-5.7977.524-6.3804,3.059c0,0-2.4618-2.294-.4341-5.594s4.7333-.623,7.9741-2.106c3.2407-1.482,2.7531,2.965,2.7531,2.965v.006Z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8193,175.1c0,0-.1903,4.123,3.2229,4.935s5.8334,1.247,5.6966,4.376",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4616,175.1c0,0,.1903,4.123-3.2229,4.935s-5.8333,1.247-5.6966,4.376",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6539,179.759c0,0,2.0694,1.505,4.8225,1.505c2.7532,0,4.3884-1.705,4.3884-1.705",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3676,166.112c-.2081,0-.3984.076-.5649.206-.553-3.594-3.1992-6.324-6.3804-6.324s-5.81556,2.718-6.37452,6.306c-.16649-.118-.34488-.188-.54706-.188-.66599,0-1.20116.753-1.20116,1.676c0,.924.54112,1.677,1.20116,1.677.20218,0,.39246-.077.55896-.2.60058,3.523,3.21692,6.182,6.35662,6.182s5.768-2.665,6.3626-6.194c.1724.135.3687.218.5827.218.666,0,1.2012-.753,1.2012-1.677c0-.923-.5411-1.676-1.2012-1.676l.006-.006Z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4895,160.705c0,0-1.1595,2.295,1.4509,4.736l.7731,1.341c0,0,2.3666-2.006.9157-5.212-1.219-1.947-3.1397-.859-3.1397-.859v-.006Z",
    fill: "#e1e6ed",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2042,160.782c0,0-.6303,1.723-3.9127,1.67-3.2883-.047-5.79769.524-6.38043,3.059c0,0-2.46179-2.294-.43409-5.594s4.73332-.623,7.97402-2.106c3.2408-1.482,2.7532,2.965,2.7532,2.965v.006Z",
    fill: "#e1e6ed",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2111,175.1c0,0-.1902,4.123,3.223,4.935s5.8333,1.247,5.6966,4.376",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8475,175.1c0,0,.1903,4.123-3.22291,4.935s-5.83335,1.247-5.69659,4.376",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0458,179.759c0,0,2.0693,1.505,4.8225,1.505s4.3884-1.705,4.3884-1.705",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9426,174.217c.0178-.206.0297-.411.0297-.623c0-1.853-.7432-3.518-1.9325-4.683c1.9504-2.047,3.1634-4.894,3.1634-8.047c0-6.229-4.7333-11.276-10.5666-11.276-5.8334,0-10.5667,5.047-10.5667,11.276c0,3.089,1.1655,5.889,3.0505,7.93-1.2547,1.17-2.0515,2.882-2.0515,4.8c0,.212.0119.417.0298.623",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6903,157.265c-.3092.688-.5292,1.435-.6541,2.223-.1665-.117-.3449-.188-.5471-.188-.666,0-1.2011.753-1.2011,1.676c0,.924.5411,1.677,1.2011,1.677.2022,0,.3925-.077.559-.2.6006,3.523,3.2169,6.182,6.3566,6.182s5.768-2.664,6.3626-6.194c.1724.135.3687.218.5827.218.666,0,1.2012-.753,1.2012-1.677c0-.923-.5411-1.676-1.2012-1.676-.2081,0-.3984.076-.5649.206-.1248-.794-.3449-1.541-.6541-2.23",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1936,168.288c0,0-.1903,4.124,3.2229,4.935c3.4132.812,5.8333,1.247,5.6966,4.377",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8359,168.288c0,0,.1903,4.124-3.2229,4.935-3.4132.812-5.8334,1.247-5.6966,4.377",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0282,172.941c0,0,2.0693,1.506,4.8225,1.506c2.7531,0,4.3884-1.706,4.3884-1.706",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6665,157.253c.779,0,1.4985-.253,2.0753-.689.5768-.435,1.2368-.876,1.9147-1.205.8384-.406,1.4806-1.142,1.7661-2.036.2854.894.9335,1.624,1.766,2.036.6779.329,1.3082.752,1.9147,1.205.6066.453,1.2963.689,2.0753.689",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eaYSWl59rqw81"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 36,
    rx: 0,
    ry: 0,
    transform: "translate(3.33337 149)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerOffer);
export default __webpack_public_path__ + "static/media/power-offer.7b39832a3ce4cc9db7cb6a7842e400a0.svg";
export { ForwardRef as ReactComponent };